/* common components */
// 原生数据类型扩展
export default {
	install(app) {
		// 手动注册自定义组件，也可以通过vite自动加载江组件加载到这里，但是注意文件名要区别，不能一样
        // 扫描 ./components 目录及其子目录下的所有.vue 文件
        const moduleFiles = import.meta.glob('@/components/Vu**/Index.vue')
        // 全局注册组件
        for(let path in moduleFiles) {
            let segs = path.split('/')
			// 按照指定格式取得 componentName
			const componentName = segs[segs.length - 2]
            // 注册
            app.component(componentName, defineAsyncComponent(moduleFiles[path]));
        }
    }
}